/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import {
  IconPlus,
  IconDotsVertical,
  IconMinus,
  IconCloudUpload,
} from "@tabler/icons-react";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import ToggleButton from "../../../components/ToggleButton";
import RoleToggle from "../../../components/RoleToggle";
import { FieldError, useForm } from "react-hook-form";
import NewinputField from "../../../components/NewInput";
import TextareaField from "../../../components/common/TextareaField";
import NewSelectInput from "../../../components/NewSelectInput";
import AddNewTrigger from "./AddNewTrigger";
import ViewNotificationModal from "./ViewNotificationModal";
import { useFetchStaffsAllData } from "../../../apis/staffApis";
import { useMerchantAllListData } from "../../../apis/merchantApis";
import { useFetchDriversAllData } from "../../../apis/driverApis";
import MultiSelectInputCheckbox from "../../../components/MultiSelectInputCheckbox";
import {
  useFetchNotificationsData,
  useNotificationCreateMutation,
  useNotificationStatusMutation,
  useNotificationUpdateMutation,
} from "../../../apis/notificationApis";
import toast from "react-hot-toast";
import ButtonStyled from "../../../components/common/ButtonStyled";
import formatDate, { sanitizePayload } from "../../../utilities/helper";
import { getSocket } from "../../../socket";
import { useSelector } from "react-redux";
import MessageModal from "../../../components/MessageModal";
import NoDataFound from "../../../components/common/NoDataFound";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import Pagination from "../../../components/common/Pagination";
import useDebounce from "../../../utilities/useDebounce";
import {
  useFetchShipmentNotificationTemplate,
  useUpdateShipmentTemplateStatus,
} from "../../../apis/tamplateNotification";
import ViewShipmentNotificationModal from "./ViewShipmentNotificationModal";

const roles = ["System", "Shipment"];
type FormValues = {
  stepName?: string;
  eventCondition?: string;
  messageEnglish?: string;
  messageArabic?: string;
  channels?: string[];
  selectFor: string;
  recipients: SelectedValue[];
  notificationTitle: string;
  notificationMessage: string;
  date?: string;
  time?: string;
};

type SelectedValue = {
  id?: string;
  value: string;
  text: string;
  type?: string;
};

const NotificationMange: React.FC = () => {
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [activeModal, setActiveModal] = useState<boolean>(false);
  const [id, setId] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  const [shipmentStatusModal, setShipmentStatusModal] = useState(false);
  const [shipmentStatusValue, setShipmentStatusValue] = useState<
    "ACTIVE" | "INACTIVE"
  >("ACTIVE");
  const [shipmentStatusId, setShipmentStatusId] = useState<string>("");
  const [systemMode, setSystemMode] = useState<"create" | "edit">("create");
  const [editingNotification, setEditingNotification] = useState<any>(null);

  const {
    setValue,
    watch,
    clearErrors,
    control,
    reset,
    formState: { errors },
    handleSubmit,
    register,
    unregister,
    getValues,
  } = useForm<FormValues>();
  const { mutate: createNotification, isPending } =
    useNotificationCreateMutation();
  const { mutate: updateNotification, isPending: isUpdatePending } =
    useNotificationUpdateMutation(editingNotification?.id || "");
  const {
    data,
    isPending: listPending,
    refetch,
    isFetching,
  } = useFetchNotificationsData(pageNo, limit, searchFor);
  const { mutate: statusMutate, isPending: isStatusPending } =
    useNotificationStatusMutation(id);

  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
    null
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenDropdownIndex(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [activeRole, setActiveRole] = useState("System");

  const [scheduleLater, setScheduleLater] = useState(false);

  const onSubmit = (data: any) => {
    const file = fileInputRef?.current?.files?.[0];
    const payload = sanitizePayload({
      title: data?.notificationTitle,
      message: data?.notificationMessage,
      for: data?.selectFor,
      scheduleDate: data?.date,
      scheduleTime: data?.time,
      recipients: data?.recipients.map((r: any) => ({
        id: r.id,
        type: r.type,
      })),
      image: file,
    });

    if (systemMode === "edit") {
      updateNotification(payload, {
        onSuccess: (res: any) => {
          clearErrors();
          reset();
          setIsModalOpen(false);
          setSystemMode("create");
          setEditingNotification(null);
          refetch();
          toast.success(res?.message || "Notification Updated Successfully");
        },
        onError: (error: any) => {
          console.error(error);
          toast.error(error?.response?.data?.message || "Something went wrong");
        },
      });
    } else {
      createNotification(payload, {
        onSuccess: (res: any) => {
          clearErrors();
          reset();
          setIsModalOpen(false);
          refetch();
          const socket = getSocket();
          if (socket) {
            // 🔥 emit one by one
            data.recipients.forEach((recipient: { id: string; type: string }) => {
              socket.emit(
                "New Notification",
                recipient // include single recipient
              );
            });
          }
          toast.success(res?.message || "Notification Created Successfully");
        },
        onError: (error: any) => {
          console.error(error);
          toast.error(error?.response?.data?.message || "Something went wrong");
        },
      });
    }
  };

  useEffect(() => {
    if (!scheduleLater) {
      // Clear date/time fields when scheduleLater is false
      reset({
        ...getValues(), // keep other form values
        date: undefined,
        time: undefined,
      });

      // OR unregister fields to remove them from form data completely
      unregister("date");
      unregister("time");
    }
  }, [scheduleLater]);

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [fileName, setFileName] = useState<string>(""); // store file name

  const handleFileClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      if (file.size > MAX_FILE_SIZE) {
        toast.error(`File size must be 1 MB or less`);
        if (fileInputRef.current) fileInputRef.current.value = "";
        setFileName("");
        return;
      }

      setFileName(file.name);
    }
  };

  const [notification, setNotification] = useState<any>();
  const [isViewNotificationOpen, setIsViewNotificationOpen] = useState(false);
  const [isViewShipmentOpen, setIsViewShipmentOpen] = useState(false);

  const [shipmentMode, setShipmentMode] = useState<"create" | "edit">("create");
  const [editingShipmentTemplate, setEditingShipmentTemplate] =
    useState<any>(null);

  const [selectedShipmentTemplateId, setSelectedShipmentTemplateId] = useState<
    string | null
  >(null);

  const { data: staffData } = useFetchStaffsAllData();
  const { data: clients } = useMerchantAllListData();
  const { data: driverData } = useFetchDriversAllData("");
  const selectFor = watch("selectFor");

  // Map each type to its data and how to extract the name
  const recipientMap: Record<
    string,
    { data: any[]; getText: (item: any) => string }
  > = {
    Staff: { data: staffData || [], getText: (s: any) => s?.name },
    Client: { data: clients || [], getText: (c: any) => c?.name },
    Driver: { data: driverData || [], getText: (d: any) => d?.name },
  };

  // Determine which types to include
  const typesToInclude =
    selectFor === "All" ? Object.keys(recipientMap) : [selectFor];

  // Build recipientsData
  const recipientsData = watch("selectFor")
    ? typesToInclude?.flatMap((type) =>
      recipientMap[type]?.data.map((item) => ({
        id: item?.id,
        value: item?.id,
        text: recipientMap[type].getText(item),
        type,
      }))
    )
    : [];

  // Auto-fill recipients when opening in edit mode
  // Directly use raw data sources (stable query results) instead of the derived
  // `recipientsData` variable which changes reference every render and depends
  // on selectFor being set first.
  useEffect(() => {
    if (systemMode !== "edit" || !editingNotification) return;

    const apiRecipients: { id: string; type: string }[] =
      editingNotification.recipients || [];

    if (apiRecipients.length === 0) return;

    const allSources: Record<
      string,
      { data: any[]; getText: (item: any) => string }
    > = {
      Staff: { data: staffData || [], getText: (s: any) => s?.name },
      Client: { data: clients || [], getText: (c: any) => c?.name },
      Driver: { data: driverData || [], getText: (d: any) => d?.name },
    };

    const matched = apiRecipients
      .map((r) => {
        const source = allSources[r.type];
        if (!source) return undefined;
        const found = source.data.find((item: any) => item.id === r.id);
        if (!found) return undefined;
        return {
          id: found.id,
          value: found.id,
          text: source.getText(found),
          type: r.type,
        };
      })
      .filter(Boolean) as SelectedValue[];

    if (matched.length > 0) {
      setValue("recipients", matched, {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
  }, [systemMode, editingNotification, staffData, clients, driverData]);

  const updateStatus = () => {
    statusMutate(
      { status: status === "ACTIVE" ? "INACTIVE" : "ACTIVE" },
      {
        onSuccess: (data: any) => {
          setActiveModal(false);
          refetch();
        },
        onError: (error: any) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo]);

  //  Get Notification Template

  const { data: notificationtemplate, refetch: refetchShipmentTemplates } =
    useFetchShipmentNotificationTemplate();

  // Status Notification
  const { mutate: updateShipmentStatus } = useUpdateShipmentTemplateStatus();

  const confirmShipmentStatusChange = () => {
    updateShipmentStatus(
      {
        id: shipmentStatusId,
        status: shipmentStatusValue,
      },
      {
        onSuccess: () => {
          toast.success("Shipment template status updated");
          setShipmentStatusModal(false);
          refetchShipmentTemplates();
        },
        onError: (err: any) => {
          toast.error(
            err?.response?.data?.message || "Failed to update status"
          );
        },
      }
    );
  };

  return (
    <div className="w-full">
      <div>
        <div className="flex items-start">
          <div className="bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] flex items-center justify-between px-6 py-3 w-full rounded-tl-[20px] rounded-tr-[30px]">
            <h1 className="text-lg font-medium text-[#212121]">
              Notification Lists
            </h1>
            <div className="flex gap-2">
              <NormalSearch
                value={searchFor}
                onChange={(e) => {
                  setSearchFor(e.target.value);
                  setPageNo(1);
                }}
              />
              <button
                type="button"
                onClick={() => {
                  if (isModalOpen) {
                    setIsModalOpen(false);
                    setSystemMode("create");
                    setEditingNotification(null);
                    reset();
                  } else {
                    setIsModalOpen(true);
                  }
                }}
                className="bg-[#FBD037] text-[#212121] text-sm font-semibold p-2 rounded-full"
              >
                {isModalOpen ? (
                  <IconMinus stroke={1.5} size={24} />
                ) : (
                  <IconPlus stroke={1.5} size={24} />
                )}
              </button>
            </div>
          </div>
        </div>
        {isModalOpen && (
          <div className="bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] px-6 py-3 w-full ">
            <div className="flex justify-between items-center">
              <h2>{systemMode === "edit" ? "Edit Notification" : "Create Notification"}</h2>

              <RoleToggle
                options={roles}
                active={activeRole}
                onChange={setActiveRole}
                activeClassName="bg-[#FBD037] text-[#212121]"
                inactiveClassName="bg-transparent text-[#212121]/70"
                containerClassName="inline-flex rounded-full bg-white border border-[#D8D8D8] py-0.5 px-1 space-x-2"
              />
            </div>
            {activeRole === "System" && (
              <form onSubmit={handleSubmit(onSubmit)} className="py-4">
                <div className="grid grid-cols-4 gap-4">
                  {/* Notification Title */}
                  <div className="col-span-4 space-y-1">
                    <NewinputField
                      type="text"
                      name="notificationTitle"
                      title="Notification Title"
                      placeholder="Limited Time Offer: [Discount]% Off"
                      register={register}
                      error={errors?.notificationTitle}
                      validation={{
                        required: "Notification Title is Required",
                        maxLength: {
                          value: 60,
                          message: "Notification Title cannot exceed 60 characters",
                        },
                        pattern: {
                          value: /^[a-zA-Z0-9\s.,!@#$%&()_+=\-:[\]?/\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]*$/,
                          message: "Notification Title contains unsupported special characters",
                        },
                      }}
                    />
                    <p className="text-sm text-[#212121]/70">
                      Maximum 60 characters
                    </p>
                  </div>

                  <div className="col-span-4 space-y-1">
                    <TextareaField
                      placeholder="For A Limited Time, Enjoy [Discount]% Off On [Product/Service]. Use Code [CODE] At Checkout. Offer Valid Until [End Date)."
                      label="Notification Message"
                      name="notificationMessage"
                      register={register}
                      error={errors.notificationMessage}
                      validation={{
                        required: "Notification Message is required",
                      }}
                      handleFileChange={handleFileChange}
                      handleFileClick={handleFileClick}
                      fileInputRef={fileInputRef}
                      fileName={fileName}
                    />
                    <p className="text-sm text-[#212121]/70">
                      Maximum 500 characters
                    </p>
                  </div>

                  <NewSelectInput
                    label="Select For"
                    className="col-span-1"
                    name="selectFor"
                    selectOptions={
                      ["All", "Client", "Staff", "Driver"]?.map((r: any) => ({
                        id: r,
                        value: r,
                        text: r,
                      })) || []
                    }
                    register={register}
                    clearErrors={clearErrors}
                    validation={{ required: "Select For is required" }}
                    error={errors.selectFor}
                    value={watch("selectFor")}
                    setValue={(val: string) => {
                      setValue("selectFor", val);
                    }}
                  />
                  <MultiSelectInputCheckbox
                    label="Recipients"
                    name="recipients"
                    selectOptions={recipientsData} // array of objects { id, text, type }
                    register={register}
                    clearErrors={clearErrors}
                    validation={{ required: "Recipients is required" }}
                    error={errors.recipients as FieldError | undefined}
                    value={
                      Array.isArray(watch("recipients"))
                        ? (watch("recipients") as SelectedValue[]) // type assertion
                        : []
                    }
                    setValue={(val: SelectedValue[]) => {
                      setValue("recipients", val, {
                        shouldValidate: true,
                        shouldDirty: true,
                      });
                    }}
                    multiple={true}
                  />

                  {/* Schedule Later Toggle */}
                  <div className="col-span-2 flex items-center gap-2">
                    <div className="flex-shrink-0 space-y-1">
                      <label className="invisible text-sm text-[#1E293]">
                        Toggle
                      </label>
                      <div className="flex items-center gap-2">
                        <p className="text-sm text-[#1E293]">Schedule Later</p>
                        <ToggleButton
                          checked={scheduleLater}
                          onChange={() => setScheduleLater((prev) => !prev)}
                        />
                      </div>
                    </div>

                    <div
                      className={`flex w-full items-center gap-2 transition-all duration-300 ${scheduleLater
                          ? "opacity-100 max-h-[60px]"
                          : "opacity-0 max-h-0 overflow-hidden"
                        }`}
                    >
                      <NewinputField
                        type="date"
                        name="date"
                        title="Date"
                        className="w-full"
                        // labelClass="text-transparent"
                        register={register}
                        validation={
                          scheduleLater ? { required: "Date is Required" } : {}
                        }
                        min={new Date().toISOString().split("T")[0]}
                      />
                      <NewinputField
                        type="time"
                        name="time"
                        title="Time"
                        className="w-full"
                        // labelClass="text-transparent"
                        register={register}
                        validation={
                          scheduleLater ? { required: "Time is Required" } : {}
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="pt-4">
                  <button
                    type="submit"
                    disabled={isPending || isUpdatePending}
                    className={`border ${isPending || isUpdatePending
                        ? "bg-gray-800 cursor-not-allowed text-[#ffffff]"
                        : "bg-[#FBD037] hover:bg-yellow-400 text-[#000000]"
                      } flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-base font-medium`}
                  >
                    {(isPending || isUpdatePending) && (
                      <svg
                        className="animate-spin h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
                        />
                      </svg>
                    )}
                    <span>{systemMode === "edit" ? "Update" : "Create"}</span>
                  </button>
                </div>
              </form>
            )}
            {activeRole === "Shipment" && (
              <AddNewTrigger
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                clearErrors={clearErrors}
                control={control}
                reset={reset}
                mode={shipmentMode}
                templateData={editingShipmentTemplate}
                onSuccess={() => {
                  refetchShipmentTemplates();
                  setIsModalOpen(false);
                  setShipmentMode("create");
                  setEditingShipmentTemplate(null);
                }}
              />
            )}
          </div>
        )}
        {activeRole === "System" && (
          <>
            {listPending ? (
              <TableSkeleton
                mainClass="bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]"
                subClassName=""
                columns={[
                  "S/N",
                  "Notification Type",
                  "Created By",
                  "Date",
                  "Sender Type",
                  "Recipients",
                  "Status",
                  "Actions",
                ]}
                rows={6}
              />
            ) : data?.notifications?.length ? (
              <ListView
                tdClassName="rounded-r-none rounded-l-none"
                trClassName="hover:bg-[#FBD037]/20"
                mainDivClassName="rounded-b-[20px] bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]"
                mailDivClassName="p-0 bg-transparent rounded-r-none rounded-br-3xl rounded-b-[20px]"
                thClassName="border-t"
                data={data?.notifications}
                onRowClick={(notification: any) =>
                  console.log("Clicked:", notification)
                }
                columns={[
                  {
                    label: "#",
                    render: (_: any, i: number) =>
                      (pageNo - 1) * limit + (i + 1),
                  },
                  {
                    label: "Notification Type",
                    render: (notification: any) => (
                      <span className="font-medium">{notification?.title}</span>
                    ),
                  },
                  {
                    label: "Created By",
                    render: (notification: any) => notification?.createdBy,
                  },
                  {
                    label: "Date",
                    render: (notification: any) =>
                      formatDate(notification?.created_at),
                  },
                  {
                    label: "Sender Type",
                    className: "text-center",
                    render: (c: any) => {
                      const typeColors: Record<string, string> = {
                        System:
                          "bg-[#EEEEEE] text-[#212121] border border-[#D2D2D2]",
                        SMS: "bg-[#EEEEEE] text-[#212121] border border-[#D2D2D2]",
                        WhatsApp:
                          "bg-[#EBF7CE] text-[#212121] border border-[#D8EFA1]",
                      };

                      const typesArray = Array.isArray(c.type)
                        ? c.type
                        : typeof c.type === "string"
                          ? [c.type]
                          : [];

                      return (
                        <div className="flex gap-1 justify-start">
                          {typesArray.map((t: string, index: number) => (
                            <button
                              key={index}
                              className={`rounded-full w-fit px-4 py-1 text-center ${typeColors[t] || ""
                                }`}
                            >
                              {t}
                            </button>
                          ))}
                        </div>
                      );
                    },
                  },
                  {
                    label: "Recipients",
                    render: (notification: any) => (
                      <span className="font-medium">
                        {notification?.recipients?.join(", ")}
                      </span>
                    ),
                  },
                  {
                    label: "Status",
                    render: (c: any) => (
                      <div className="flex items-center justify-center">
                        <ToggleButton
                          onChange={() => {
                            setId(c?.id);
                            setStatus(c?.status);
                            setActiveModal(true);
                          }}
                          checked={c?.status === "ACTIVE"}
                        />
                      </div>
                    ),
                  },
                  {
                    label: "Actions",
                    render: (c: any) => (
                      <div className="relative flex justify-center">
                        <button
                          onClick={() =>
                            setOpenDropdownIndex(
                              openDropdownIndex === c ? null : c
                            )
                          }
                          className="p-2 border rounded-full bg-[#F7F6F2]"
                        >
                          <IconDotsVertical size={20} />
                        </button>

                        {openDropdownIndex === c && (
                          <div
                            ref={dropdownRef}
                            className="absolute bg-[#F7F6F2] divide-y divide-[#979797]/50 right-14 -top-6 z-50 mt-2 w-32 rounded-xl shadow-lg overflow-hidden"
                          >
                            <div
                              onClick={() => {
                                setNotification(c);
                                setIsViewNotificationOpen(true);
                              }}
                              className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                            >
                              View
                            </div>
                            {!c?.sent && (
                              <div
                                onClick={() => {
                                  setEditingNotification(c);
                                  setSystemMode("edit");
                                  setValue("notificationTitle", c?.title || "");
                                  setValue("notificationMessage", c?.message || "");
                                  setValue("selectFor", c?.for || "");
                                  setIsModalOpen(true);
                                  setOpenDropdownIndex(null);
                                }}
                                className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                              >
                                Edit
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ),
                  },
                ]}
              />
            ) : (
              <NoDataFound
                subClassName=""
                mainClassName="bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] rounded-b-3xl"
              />
            )}

            {data?.totalPages > 1 && (
              <div className="flex justify-center items-center py-4">
                <Pagination
                  currentPage={pageNo}
                  totalPages={data?.totalPages}
                  fetchData={handlePaginationFetch}
                />
              </div>
            )}
          </>
        )}
        {activeRole === "Shipment" && (
          <>
            {!notificationtemplate?.length ? (
              <NoDataFound mainClassName="bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] rounded-b-3xl" />
            ) : (
              <ListView
                mainDivClassName="rounded-b-[20px] bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]"
                data={notificationtemplate}
                columns={[
                  {
                    label: "#",
                    render: (_: any, i: number) => i + 1,
                  },
                  {
                    label: "Event",
                    render: (row: any) => (
                      <span className="font-medium">
                        {row.orderStatus?.replace(/_/g, " ")}
                      </span>
                    ),
                  },
                  {
                    label: "Created By",
                    render: (row: any) => row.createdBy,
                  },
                  {
                    label: "Date",
                    render: (row: any) => formatDate(row.createdAt),
                  },
                  {
                    label: "Channel",
                    render: (row: any) => row.channels?.join(", "),
                  },
                  {
                    label: "Language",
                    render: (row: any) => row.languages?.join(", "),
                  },
                  {
                    label: "Status",
                    render: (row: any) => (
                      <ToggleButton
                        checked={row.status === "ACTIVE"}
                        onChange={() => {
                          setShipmentStatusId(row.id);
                          setShipmentStatusValue(
                            row.status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
                          );
                          setShipmentStatusModal(true);
                        }}
                      />
                    ),
                  },

                  // {
                  //   label: "Actions",
                  //   render: (row: any) => (
                  //     <button
                  //       onClick={() => {
                  //         setSelectedShipmentTemplateId(row.id);
                  //         setIsViewShipmentOpen(true);
                  //       }}
                  //       className="p-2 border rounded-full bg-[#F7F6F2]"
                  //     >
                  //       <IconDotsVertical size={20} />
                  //     </button>
                  //   ),
                  // },
                  {
                    label: "Actions",
                    render: (row: any) => (
                      <div className="relative flex justify-center">
                        <button
                          onClick={() =>
                            setOpenDropdownIndex(
                              openDropdownIndex === row ? null : row
                            )
                          }
                          className="p-2 border rounded-full bg-[#F7F6F2]"
                        >
                          <IconDotsVertical size={20} />
                        </button>

                        {openDropdownIndex === row && (
                          <div
                            ref={dropdownRef}
                            className="absolute bg-[#F7F6F2] divide-y divide-[#979797]/50 right-16 -top-7 z-50 mt-2 w-32 rounded-xl shadow-lg overflow-hidden"
                          >
                            <div
                              onClick={() => {
                                setSelectedShipmentTemplateId(row.id);
                                setIsViewShipmentOpen(true);
                              }}
                              className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                            >
                              View
                            </div>
                            {!row?.sent && (
                              <div
                                onClick={() => {
                                  setEditingShipmentTemplate(row);
                                  setShipmentMode("edit");
                                  setIsModalOpen(true);
                                  setActiveRole("Shipment");
                                  setOpenDropdownIndex(null);
                                }}
                                className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                              >
                                Edit
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ),
                  },
                ]}
              />
            )}
          </>
        )}
      </div>
      <ViewNotificationModal
        notification={notification}
        open={isViewNotificationOpen}
        onClose={() => setIsViewNotificationOpen(false)}
        refetch={refetch}
      />

      {/* <ViewShipmentNotificationModal
        open={isViewShipmentOpen}
        templateId={selectedShipmentTemplateId || undefined}
        onClose={() => {
          setIsViewShipmentOpen(false);
          setSelectedShipmentTemplateId(null);
        }}
        // refetchList={refetchShipmentTemplates}
      /> */}
      <ViewShipmentNotificationModal
        open={isViewShipmentOpen}
        templateId={selectedShipmentTemplateId}
        onEdit={() => {
          setIsViewShipmentOpen(false);
          setIsModalOpen(true);
          setActiveRole("Shipment");
        }}
        onClose={() => {
          setIsViewShipmentOpen(false);
          setSelectedShipmentTemplateId(null);
        }}
      />

      <MessageModal
        open={activeModal}
        onClose={() => setActiveModal(false)}
        title="Confirmation Required"
        subtitle="Are you sure you want to perform this action?"
        img={status === "ACTIVE" ? "/img/inactive.svg" : "/img/active.svg"}
        showFooter={true}
        closeButtonText="Cancel"
        actionButtonText="Confirm"
        actionButtonOnClick={updateStatus}
        isPending={isStatusPending}
        size="md"
      />
      <MessageModal
        open={shipmentStatusModal}
        onClose={() => setShipmentStatusModal(false)}
        title="Confirmation Required"
        subtitle="Are you sure you want to change this shipment template status?"
        img={
          shipmentStatusValue === "ACTIVE"
            ? "/img/active.svg"
            : "/img/inactive.svg"
        }
        showFooter={true}
        closeButtonText="Cancel"
        actionButtonText="Confirm"
        actionButtonOnClick={confirmShipmentStatusChange}
        size="md"
      />
    </div>
  );
};

export default NotificationMange;
